export enum StatusId {
  Unknown,
  Active,
  Frozen,
  Closed,
  Pending,
  Suspended,
  Preparation,
}
